/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

jQuery(document).ready(function ($) {
    const $form = $('.filter-reasonable-filter-form__form');

    $form.on('submit', function (e) {
        e.preventDefault();
        const formData = $(this).serialize();

        history.replaceState(null, null, '?' + formData);

        const $result_spinner = $('.filter-reasonable-filter-result__spinner');
        if (!$result_spinner.hasClass('filter-reasonable-filter-result__spinner--active')) {
            $result_spinner.addClass('filter-reasonable-filter-result__spinner--active');
        }
        $('.filter-reasonable-filter-result').load(window.location.href + ' .filter-reasonable-filter-result', null, function () {
            $result_spinner.removeClass('filter-reasonable-filter-result__spinner--active');
        });
    });

    let taxCountAjaxCall = null;

    function fetchAsyncData() {
        // sanitize the parent form data
        const formData = $form.serialize();

        const promises = [];

        if (taxCountAjaxCall) {
            taxCountAjaxCall.abort();
        }

        // run an ajax request to get the tax counts from the wp_ajax_filter_reasonable_tax_counts hook
        const taxCountPromise = new Promise(function (resolve) {
            taxCountAjaxCall = $.ajax({
                url: '/wp-admin/admin-ajax.php?' + formData,
                type: 'post',
                data: {
                    action: 'filter_reasonable_tax_counts'
                },
                success: function (response) {
                    // update the tax counts
                    $('.filter-reasonable-filter-field__taxonomy').each(function () {
                        const key = $(this).data('taxonomy-count-key');
                        const count = response[key] || 0;

                        if (count > 0) {
                            $(this).find('.filter-reasonable-filter-field__taxonomy-count').text(' (' + count + ')');
                        } else {
                            $(this).find('.filter-reasonable-filter-field__taxonomy-count').text(' (0)');
                        }
                    });
                    $('[data-taxonomy-count-key]').each(function () {
                        $(this).attr('data-taxonomy-count', response[$(this).data('taxonomy-count-key')] || 0);
                    });
                    resolve();
                },
                error: function () {
                    resolve();
                }
            });
        }).then(() => {
            taxCountAjaxCall = null;

            function compare(a, b) {
                const countA = parseInt(a.getAttribute('data-taxonomy-unfiltered-count'));
                const countB = parseInt(b.getAttribute('data-taxonomy-unfiltered-count'));
                if (countA < countB) {
                    return 1;
                }
                if (countA > countB) {
                    return -1;
                }
                return 0;
            }

            // change the order of the taxonomies based on the count
            $('.filter-reasonable-filter-field__sort-by-taxonomy-count:not(.filter-reasonable-filter-field__show-more)').each(function () {
                const $taxonomiesContainer = $(this).find('ul');
                // const $taxonomies = $taxonomiesContainer.find('.filter-reasonable-filter-field__taxonomy');
                const taxonomies = Array.from($taxonomiesContainer[0].children);
                taxonomies.sort(compare);
                taxonomies.forEach(function (elm) {
                    $taxonomiesContainer[0].appendChild(elm);
                });
            });
        });

        promises.push(taxCountPromise);

        const resultCountPromise = new Promise(function (resolve) {
            const $result_count = $('.filter-reasonable-result-count');
            if ($result_count.length) {
                $.ajax({
                    url: '/wp-admin/admin-ajax.php?' + formData,
                    type: 'post',
                    data: {
                        action: 'filter_reasonable_result_count',
                        plural: $result_count.data('atts-plural'),
                        singular: $result_count.data('atts-singular')
                    },
                    success: function (response) {
                        // update the tax counts
                        $result_count.replaceWith(response);
                        resolve();
                    },
                    error: function () {
                        resolve();
                    }
                });
            } else {
                resolve();
            }
        });

        promises.push(resultCountPromise);

        // add bootstrap spinner class to the form
        const $spinner = $('.filter-reasonable-filter-form__spinner');
        if (!$spinner.hasClass('filter-reasonable-filter-form__spinner--active')) {
            $spinner.addClass('filter-reasonable-filter-form__spinner--active');
        }

        Promise.all(promises).then(function () {
            // remove the spinner class from the form
            $spinner.removeClass('filter-reasonable-filter-form__spinner--active');

            $form.trigger('filter-reasonable-update', null);
        });
    }

    $form.find('*[name]').each(function () {
        const $this = $(this);
        const $field = $this.closest('.filter-reasonable-filter-field');

        let disableAjax = false;
        if ($field.hasClass('filter-reasonable-filter-field__disable-ajax')) {
            disableAjax = true;
        }

        // check, if the input has already a lost its name attribute
        if (!$this.attr('name')) {
            return;
        }

        const value = $this.val();
        const $other = $form.find('*[name="' + $this.attr('name') + '"][value="' + value + '"]').not($this);

        // check, if the other input is a checkbox or radio
        if ($other.length && ($other.is('input[type="checkbox"]') || $other.is('input[type="radio"]'))) {
            // check, if the value is also the same
            if ($this.val() === $other.val()) {
                // move the name attribute to a form-name attribute
                $other.removeAttr('name').attr('form-name', $this.attr('name'));
                // now sync the changes between the two inputs
                $this.on('change', function () {
                    const $elm = $(this);
                    const name = $elm.attr('name');
                    const checked = $elm.prop('checked');
                    const value = $elm.val();
                    $('.filter-reasonable-filter-form__form *[form-name="' + name + '"][value="' + value + '"]').prop('checked', checked);
                    $elm.closest('li').attr('aria-checked', checked ? 'checked' : 'false');
                    updateFilter(disableAjax);
                });
                $other.on('change', function () {
                    const $elm = $(this);
                    const name = $elm.attr('form-name');
                    const checked = $elm.prop('checked');
                    const value = $elm.val();
                    $('.filter-reasonable-filter-form__form *[name="' + name + '"][value="' + value + '"]').prop('checked', checked);
                    $elm.closest('li').attr('aria-checked', checked ? 'checked' : 'false');
                    updateFilter(disableAjax);
                });
            }
        } else {
            // move the name attribute to a form-name attribute
            $other.removeAttr('name').attr('form-name', $this.attr('name'));
            // now sync the changes between the two inputs
            $this.on('change', function () {
                const $elm = $(this);
                const name = $elm.attr('name');
                const value = $elm.val();
                $('.filter-reasonable-filter-form__form *[form-name="' + name + '"]').val(value);
                updateFilter(disableAjax);
            });
            $other.on('change', function () {
                const $elm = $(this);
                const name = $elm.attr('form-name');
                const value = $elm.val();
                $('.filter-reasonable-filter-form__form *[name="' + name + '"]').val(value);
                updateFilter(disableAjax);
            });
        }
    });

    $form.find('.filter-reasonable-filter-field__address').on('address-selected', function () {
        window.requestAnimationFrame(() => {
            updateFilter();
        });
    });

    function updateFilter(disableAjax = false) {
        if (disableAjax) {
            $form.off('submit');
            $form.submit();
        } else {
            $form.submit();
            fetchAsyncData();
        }
    }

    $(".filter-reasonable-filter-form__form").on('reset', (event) => {
        // prevent the default reset
        event.preventDefault();
        // reset the url
        window.location.href = window.location.pathname
    });
});